import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DesignSystemNavigationModule } from '@montebravo.tech/design-system-navigation';
import { NavbarModule } from '../../layout/navbar/navbar.module';
import { WealthServicesModule } from '../wealth-services/wealth-services.module';
import { AppShellRoutingModule } from './app-shell-routing.module';
import { AppShellComponent } from './app-shell.component';
import { AppShellService } from './app-shell.service';

@NgModule({
    declarations: [AppShellComponent],
    imports: [
        AppShellRoutingModule,
        MatButtonModule,
        DesignSystemNavigationModule,
        MatTooltipModule,
        NavbarModule,
        WealthServicesModule,
    ],
    providers: [AppShellService],
})
export class AppShellModule {}
